import { render, staticRenderFns } from "./precanned_btn.vue?vue&type=template&id=47d79c6d&"
import script from "./precanned_btn.vue?vue&type=script&lang=js&"
export * from "./precanned_btn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports